import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { RentalAgreementSearchDto } from '../../rental-agreements';
import { VehicleSearchDto } from '../../vehicles';

/**
 * Resolved related records for a vehicle damage activity event, keyed by relation.
 */
export class VehicleDamageActivityEventHydration {
  vehicle?: ActivityFieldHydration<VehicleSearchDto>;
  rentalAgreement?: ActivityFieldHydration<RentalAgreementSearchDto>;
  link?: ActivityLinkHydration;
}
